import { useAuth0 } from '@auth0/auth0-react';
import {
  Avatar,
  Box,
  Button,
  Container,
  Paper,
  Typography
} from '@mui/material';
import { Helmet } from 'react-helmet';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <>
      <Helmet>
        <title>Login | Rayo WMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: `url(https://rayo.s3.us-west-1.amazonaws.com/bg_high.jpg)`,
          backgroundSize: 'cover',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container
          maxWidth="md"
          padding="16px"
          styles={{ backgroundColor: '#fff' }}
        >
          <Paper elevation={24} padding="16px">
            <Box
              display="flex"
              justifyContent="center"
              sx={{ my: 5 }}
              md={{ my: 3 }}
            >
              <Avatar
                src="https://rayo.s3.us-west-1.amazonaws.com/Rayo+simbolo+blanco_auto_x2.jpg"
                style={{
                  width: 160,
                  height: 160,
                  alignSelf: 'center',
                  paddingTop: '32px'
                }}
              />
            </Box>
            <Box
              sx={{
                mb: 3,
                backgroundImage: `url(https://rayo.s3.us-west-1.amazonaws.com/TYPO_LOGO_ALTA-removebg-preview.png)`,
                backgroundSize: '25%',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: '50% 50%',
                align: 'center',
                display: 'flex',
                height: 70
              }}
            />
            <Box sx={{ py: 2 }} paddingX="100px">
              <Button
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={() => {
                  loginWithRedirect();
                }}
              >
                Iniciar Sesion
              </Button>
            </Box>
            <Typography
              color="textSecondary"
              variant="body1"
              mb={3}
              padding="52px"
              align="center"
            >
              Recuerda que debes tener una cuenta de correo registrada con Rayo.
              <br />
              Contacta a tu proveedor de servicio de fulfillment para activarla.
            </Typography>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Login;
